export type PlanId = 'one-time' | 'monthly'; // extensible

type StripeInterval = 'month'; // | 'year'; // other options: 'day' | 'week'  | 'year';

export type DonationPlan =
  | {
      id: 'one-time';
      label: string;
      // one-time no debe llevar recurring
      recurring?: undefined;
      default?: boolean;
    }
  | {
      id: Exclude<PlanId, 'one-time'>; // p.ej. 'monthly' | 'yearly'
      label: string;
      recurring: {
        interval: StripeInterval;
        interval_count?: number; // ej. cada 3 meses, etc.
      };
      default?: boolean;
    };

// Registro por defecto (puedes añadir yearly sin tocar más código)
export const DEFAULT_DONATION_PLANS: DonationPlan[] = [
  {
    id: 'monthly',
    label: 'CAMPAIGN.DonationType.Monthly', // clave de traducción
    recurring: { interval: 'month' },
    default: true,
  },
  { id: 'one-time', label: 'CAMPAIGN.DonationType.OneTime', default: false },
  // { id: 'yearly', label: 'CAMPAIGN.DonationType.Yearly', recurring: { interval: 'year' } },
];

export type PriceFormValue = {
  donationType: PlanId | null;
  unitAmount: number | null;
  nickname: string;
  currency: string; // 'USD'
};

export type PriceInput = PriceDraft & {
  donationType?: DonationType;
};

// InjectionToken para configurar/inyectar planes
import { InjectionToken } from '@angular/core';
import { PriceEnvelope } from './stripe-models';
import { DonationType, PriceDraft } from './donation-flow.models';
export const DONATION_PLANS = new InjectionToken<DonationPlan[]>(
  'DONATION_PLANS'
);
